<template>
  <div>
    <div class="dashboard-main-content" v-if="additionalServicePricingTemplate">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <form id="priceForm">
              <div class="form-box">
                <div class="form-content pb-2">
                  <h3 class="title">Ek Hizmet Fiyatlandırma</h3>
                  <div class="row justify-content">
                    <div class="contact-form-action col-sm-4">
                      <div class="input-box">
                        <base-edit-input
                            v-model="additionalServicePricingTemplate.name"
                            :type="'text'"
                            :label="'Adı'">
                        </base-edit-input>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="input-box">
                        <base-select-input
                            v-model="additionalServicePricingTemplate.cruiseId"
                            :optionList="cruiseList"
                            :rules="'required'"
                            :label="'Cruise'"
                            :href="basePath+'/cruises/'+additionalServicePricingTemplate.cruiseId"
                            :href-text="additionalServicePricingTemplate.cruiseId">
                        </base-select-input>
                      </div>
                    </div>
<!--                    <div class="col-sm-4" v-show="additionalServicePricingTemplate.id != null">-->
<!--                      <div class="input-box">-->
<!--                        <base-select-input-->
<!--                            v-model="pricingMarketId"-->
<!--                            :optionList="marketList"-->
<!--                            :label="'Market'">-->
<!--                        </base-select-input>-->
<!--                      </div>-->
<!--                    </div>-->
                  </div>
                  <div class="row justify-content-between">
                    <div class="col-sm-4">
                      <div class="input-box">
                        <base-select-input
                            v-model="additionalServiceId"
                            :optionList="additionalServiceList"
                            :label="'Ek Hizmet'">
                        </base-select-input>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="input-box">
                        <base-select-input
                            v-model="additionalServicePricingTemplate.pricingMethod"
                            :optionList="additionalServicePricingMethodList"
                            :label="'Method'">
                        </base-select-input>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="input-box">
                        <base-select-input
                            v-model="additionalServicePricingTemplate.pricingFactor"
                            :optionList="additionalServicePricingFactorList"
                            :label="'Faktör'">
                        </base-select-input>
                      </div>
                    </div>
                  </div>
                  <div class="row justify-content-between">
                    <div class="col-sm-6 pl-4">
                      <div class="row" >
                        <div class="input-box mb-2">
                          <base-select-input
                              v-model="selectedPricingPeriodId"
                              :optionList="pricingPeriodList"
                              :rules="'required'"
                              :label="'Fiyatlandırma Periyodu'">
                          </base-select-input>
                        </div>
                        <div class="btn-box mt-auto p-auto ml-lg-2 mb-lg-2">
                          <button :disabled="selectedPricingPeriodId === 0"
                                  :class="selectedPricingPeriodId === 0 ? 'disabled' : ''"
                                  @click="openEditPricingPeriodModal" class="theme-btn" type="button">Güncelle</button>
                          <button @click="openCreatePricingPeriodModal" class="theme-btn" type="button">Yeni</button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-end" >
                      <div class="btn-box mt-2">
                        <button @click="create" class="theme-btn" type="button">Kaydet</button>
                        <button @click="update" class="theme-btn" type="button">Güncelle</button>
                      </div>
                    </div>
                  </div>
                  <div class="row justify-content-between">
                    <div class="table-form table-responsive"  v-if="selectedAdditionalService">
                      <table class="table">
                        <thead>
                        <tr>
                          <th scope="col">Seçenek Adı</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'matrix'">01/10</th>

                          <th v-if="additionalServicePricingTemplate.pricingMethod !== 'matrix'">Ücret</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod !== 'matrix'">Vergi</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">Yalnız Misafir Çarpanı</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">İkinci Misafir Çarpanı</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">Üçüncü Misafir Çarpanı</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">Dördüncü Misafir Çarpanı</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">Extra Misafir Çarpanı</th>

                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">İlk Gece Çarpanı</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">İkinci Gece Çarpanı</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">Üçüncü Gece Çarpanı</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">Dördüncü Gece Çarpanı</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">Extra Gece Çarpanı</th>


                          <th v-if="(!additionalServicePricingTemplate.pricingMethod || !additionalServicePricingTemplate.pricingFactor) ||
                                    additionalServicePricingTemplate.pricingFactor === 'single' && additionalServicePricingTemplate.pricingMethod !== 'matrix'">Fix Ücret</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'fixed' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">Kişi Başı Ücret</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'fixed' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">Gecelik Ücret</th>


                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">Yalnız Misafir Ücreti</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">İkinci Misafir Ücreti</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">Üçüncü Misafir Ücreti</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">Dördüncü Misafir Ücreti</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">Extra Misafir Ücreti</th>


                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">İlk Gece Ücreti</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">İkinci Gece Ücreti</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">Üçüncü Gece Ücreti</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">Dördüncü Gece Ücreti</th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">Extra Gece Ücreti</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="option in selectedAdditionalService.options" :key="option.id">
                          <th scope="row">
                            <input type="text" disabled :value="option.name">
                          </th>
                          <th>
                            <input v-if="additionalServicePricingTemplate.pricingMethod === 'matrix'" class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].adultPrice"
                                   @input="additionalServicePriceMap[option.id].adultPrice = parseFloat($event.target.value)">
                          </th>
                          <th>
                            <input v-if="additionalServicePricingTemplate.pricingMethod !== 'matrix'" class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].adultPrice"
                                   @input="additionalServicePriceMap[option.id].adultPrice = parseFloat($event.target.value)">
                          </th>
                          <th>
                            <input v-if="additionalServicePricingTemplate.pricingMethod !== 'matrix'" class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].taxPrice"
                                   @input="additionalServicePriceMap[option.id].taxPrice = parseFloat($event.target.value)">
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' && additionalServicePricingTemplate.pricingFactor === 'perperson'">
                            <input class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].soloGuestMultiplier"
                                   @input="additionalServicePriceMap[option.id].soloGuestMultiplier = parseFloat($event.target.value)">
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' && additionalServicePricingTemplate.pricingFactor === 'perperson'">
                            <input class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].secondGuestMultiplier"
                                   @input="additionalServicePriceMap[option.id].secondGuestMultiplier = parseFloat($event.target.value)">
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' && additionalServicePricingTemplate.pricingFactor === 'perperson'">
                            <input class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].thirdGuestMultiplier"
                                   @input="additionalServicePriceMap[option.id].thirdGuestMultiplier = parseFloat($event.target.value)">
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' && additionalServicePricingTemplate.pricingFactor === 'perperson'">
                            <input class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].fourthGuestMultiplier"
                                   @input="additionalServicePriceMap[option.id].fourthGuestMultiplier = parseFloat($event.target.value)">
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' && additionalServicePricingTemplate.pricingFactor === 'perperson'">
                            <input class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].extraGuestMultiplier"
                                   @input="additionalServicePriceMap[option.id].extraGuestMultiplier = parseFloat($event.target.value)">
                          </th>


                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' && additionalServicePricingTemplate.pricingFactor === 'pernights'">
                            <input class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].firstNightMultiplier"
                                   @input="additionalServicePriceMap[option.id].firstNightMultiplier = parseFloat($event.target.value)">
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' && additionalServicePricingTemplate.pricingFactor === 'pernights'">
                            <input class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].secondNightMultiplier"
                                   @input="additionalServicePriceMap[option.id].secondNightMultiplier = parseFloat($event.target.value)">
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' && additionalServicePricingTemplate.pricingFactor === 'pernights'">
                            <input class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].thirdNightMultiplier"
                                   @input="additionalServicePriceMap[option.id].thirdNightMultiplier = parseFloat($event.target.value)">
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' && additionalServicePricingTemplate.pricingFactor === 'pernights'">
                            <input class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].fourthNightMultiplier"
                                   @input="additionalServicePriceMap[option.id].fourthNightMultiplier = parseFloat($event.target.value)">
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' && additionalServicePricingTemplate.pricingFactor === 'pernights'">
                            <input class="price-input" type="number" step=".10" v-bind:value="additionalServicePriceMap[option.id].extraNightMultiplier"
                                   @input="additionalServicePriceMap[option.id].extraNightMultiplier = parseFloat($event.target.value)">
                          </th>


                          <th v-if="(!additionalServicePricingTemplate.pricingMethod && !additionalServicePricingTemplate.pricingFactor) ||
                                      additionalServicePricingTemplate.pricingFactor === 'single' ||
                                      additionalServicePricingTemplate.pricingMethod === 'fixed'">
                            {{(parseFloat(additionalServicePriceMap[option.id].adultPrice) + parseFloat(additionalServicePriceMap[option.id].taxPrice)) | toCurrency}}
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">
                            {{((parseFloat(additionalServicePriceMap[option.id].adultPrice) * parseFloat(additionalServicePriceMap[option.id].soloGuestMultiplier)) + parseFloat(additionalServicePriceMap[option.id].taxPrice)) | toCurrency}}
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">
                            {{((parseFloat(additionalServicePriceMap[option.id].adultPrice) * parseFloat(additionalServicePriceMap[option.id].secondGuestMultiplier)) + parseFloat(additionalServicePriceMap[option.id].taxPrice)) | toCurrency}}
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">
                            {{((parseFloat(additionalServicePriceMap[option.id].adultPrice) * parseFloat(additionalServicePriceMap[option.id].thirdGuestMultiplier)) + parseFloat(additionalServicePriceMap[option.id].taxPrice)) | toCurrency}}
                          </th><th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">
                          {{((parseFloat(additionalServicePriceMap[option.id].adultPrice) * parseFloat(additionalServicePriceMap[option.id].fourthGuestMultiplier)) + parseFloat(additionalServicePriceMap[option.id].taxPrice)) | toCurrency}}
                        </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'perperson'">
                            {{((parseFloat(additionalServicePriceMap[option.id].adultPrice) * parseFloat(additionalServicePriceMap[option.id].extraGuestMultiplier)) + parseFloat(additionalServicePriceMap[option.id].taxPrice)) | toCurrency}}
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">
                            {{((parseFloat(additionalServicePriceMap[option.id].adultPrice) * parseFloat(additionalServicePriceMap[option.id].firstNightMultiplier)) + parseFloat(additionalServicePriceMap[option.id].taxPrice)) | toCurrency}}
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">
                            {{((parseFloat(additionalServicePriceMap[option.id].adultPrice) * parseFloat(additionalServicePriceMap[option.id].secondNightMultiplier)) + parseFloat(additionalServicePriceMap[option.id].taxPrice)) | toCurrency}}
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">
                            {{((parseFloat(additionalServicePriceMap[option.id].adultPrice) * parseFloat(additionalServicePriceMap[option.id].thirdNightMultiplier)) + parseFloat(additionalServicePriceMap[option.id].taxPrice)) | toCurrency}}
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">
                            {{((parseFloat(additionalServicePriceMap[option.id].adultPrice) * parseFloat(additionalServicePriceMap[option.id].fourthNightMultiplier)) + parseFloat(additionalServicePriceMap[option.id].taxPrice)) | toCurrency}}
                          </th>
                          <th v-if="additionalServicePricingTemplate.pricingMethod === 'dynamic' &&
                                    additionalServicePricingTemplate.pricingFactor === 'pernights'">
                            {{((parseFloat(additionalServicePriceMap[option.id].adultPrice) * parseFloat(additionalServicePriceMap[option.id].extraNightMultiplier)) + parseFloat(additionalServicePriceMap[option.id].taxPrice)) | toCurrency}}
                          </th>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div>
    </div>
  </div>
</template>

<script>
import BaseSelectInput from "../base/BaseSelectInput";
import BaseEditInput from "../base/BaseEditInput";
import {dd_MM_yyyy, dd_MM_yyyy_tire, ddMMyyyyHHmm, yyyy_MM_dd_tire} from "../../util/filters";
import Vue from "vue";
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "AdditionalServicePriceDetail",
  components: {BaseEditInput, BaseSelectInput},
  data:function (){
    return {
      additionalServiceId: 0,
      formValid:false,
      pricingMethodOptions:[
        {id : "static", name : "static"},
        {id : "dynamic", name : "dynamic"}
      ],
      additionalServicePricingMethodList:[
        {id : "fixed", name : "fixed"},
        {id : "dynamic", name : "dynamic"},
        {id : "matrix", name : "matrix"}
      ],
      additionalServicePricingFactorList:[
        {id : "single", name : "single"},
        {id : "pernights", name : "pernights"},
        {id : "perperson", name : "perperson"}
      ]
    }
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath;
      }
    },
    additionalServicePricingTemplate:{
      get(){
        return this.$store.getters.getAdditionalServicePricingTemplate;
      },
    },
    cruiseList:{
      get(){
        return this.$store.getters.getCruiseList;
      },
    },
    marketList:{
      get(){
        return this.$store.getters.getMarketList;
      },
      set(value){
        this.$store.commit("setMarketList",value)
      }
    },
    selectedAdditionalService:{
      get(){
        let additionalServices = this.additionalServiceList;
        if(!additionalServices || this.additionalServiceId === 0){
          return null;
        }
        return additionalServices.filter(additionalService => {
          return additionalService.id === this.additionalServiceId;
        })[0];
      }
    },
    additionalServiceList:{
      get(){
        return this.$store.getters.getAdditionalServiceList;
      }
    },
    additionalServicePriceList:{
      get(){
        let additionalServicePriceList = this.$store.getters.getAdditionalServicePriceList;

        if (additionalServicePriceList == null || !this.selectedAdditionalService) {
          return null;
        }

        let newList = [];

        for (let i = 0; i < this.selectedAdditionalService.options.length; i++) {
          let selectedAdditionalServiceOption = this.selectedAdditionalService.options[i];

          let found = false;
          let itemToBeAdded = null;
          for (let j = 0; j < additionalServicePriceList.length; j++) {
            let selectedAdditionalServicePrice = additionalServicePriceList[j];
            if(this.selectedPricingPeriodId === selectedAdditionalServicePrice.pricingPeriodId &&
                selectedAdditionalServiceOption.id === selectedAdditionalServicePrice.additionalServiceOptionId){
              itemToBeAdded = selectedAdditionalServicePrice;
            }
          }
          if(!itemToBeAdded){
            newList.push({
              id: Math.floor(Math.random() * 10100)*-1,
              pricingTemplateId : this.$route.params.id,
              pricingPeriodId : this.selectedPricingPeriodId,
              additionalServiceOptionId: selectedAdditionalServiceOption.id,
              adultPrice : 100,
              taxPrice : 100,
              firstNightMultiplier : 1,
              secondNightMultiplier : 1,
              thirdNightMultiplier : 1,
              fourthNightMultiplier : 1,
              extraNightMultiplier : 1,
              soloGuestMultiplier : 1,
              secondGuestMultiplier : 1,
              thirdGuestMultiplier : 1,
              fourthGuestMultiplier : 1,
              extraGuestMultiplier : 1
            });
          }else{
            newList.push(itemToBeAdded);
          }
        }
        return newList;
      },
      set(value){
        this.$store.commit("setAdditionalServicePriceList", value);
      }
    },
    pricingMarketId:{
      get(){
        return this.$store.getters.getPricingMarketId;
      },
      set(value){
        this.$store.commit("setPricingMarketId",value)
      }
    },
    selectedPricingPeriodId:{
      get(){
        return this.$store.getters.getSelectedPricingPeriodId;
      },
      set(val){
        this.$store.commit("setSelectedPricingPeriodId", val);
      }
    },
    projectName:{
      get(){
        return this.$store.getters.getProjectName;
      }
    },
    additionalServicePriceMap: {
      get() {
        let additionalServicePriceList = this.additionalServicePriceList;
        if (additionalServicePriceList == null) {
          return null;
        }

        return additionalServicePriceList.reduce(function (map, additionalServicePrice) {
          map[additionalServicePrice.additionalServiceOptionId] = additionalServicePrice;
          return map;
        }, {});
      },
      set(value){
        this.additionalServicePriceMap = value;
      }
    },
    pricingPeriodList:{
      get(){
        let pricingPeriodList =  this.$store.getters.getAdditionalServicePricingPeriodList;

        pricingPeriodList.sort(function(a,b){
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });

        if(pricingPeriodList.filter(pricingPeriod=> pricingPeriod.id === 0).length === 0) {
          pricingPeriodList.push({
            id: 0,
            startDate: "2000-01-01",
            endDate: "2030-01-01"
          })
        }

        pricingPeriodList.forEach(pricingPeriod => {
          pricingPeriod.startDate = yyyy_MM_dd_tire(pricingPeriod.startDate);
          pricingPeriod.endDate = yyyy_MM_dd_tire(pricingPeriod.endDate);

          if(pricingPeriod.id === 0){
            pricingPeriod.name = "Standart Periyod";
          }else{
            pricingPeriod.name = dd_MM_yyyy(pricingPeriod.startDate) + " - " + dd_MM_yyyy(pricingPeriod.endDate);
          }
        })

        return pricingPeriodList;
      },
    }
  },
  methods:{
    create(){
      // if(this.formValid){
      //   this.$store.dispatch("createPrice", this.price).then(response => {
      //     messagePopupManager.showSuccess();
      //   })
      // }
    },
    update(){
      let prices = [];
      for (let i = 0; i < this.selectedAdditionalService.options.length; i++) {
        let item = this.additionalServicePriceMap[this.selectedAdditionalService.options[i].id];
        if(item.id < 0) item.id = 0;
        prices.push(item);
      }
      this.$store.dispatch("updateAdditionalServicePricingTemplate", this.additionalServicePricingTemplate).then(response => {
        this.$store.dispatch("createOrUpdateAdditionalServicePrices", prices).then(response => {
          messagePopupManager.showSuccess()
        })
      });
    },
    openCreatePricingPeriodModal(){
      this.$store.commit("setEditPricingPeriod", {});
      $("#createAdditionalServicePricingPeriodModal").modal("show");
    },
    openEditPricingPeriodModal(){
      let selectedPricingPeriod = this.pricingPeriodList.filter(pricingPeriod => pricingPeriod.id === this.selectedPricingPeriodId)[0];
      this.$store.commit("setEditPricingPeriod", JSON.parse(JSON.stringify(selectedPricingPeriod)));
      $("#createAdditionalServicePricingPeriodModal").modal("show");
    },
    updateAdditionalServicePrice(optionId, event){
      Vue.set(this.additionalServicePriceMap[optionId], 'adultPrice', parseFloat(event))
    }
  },
  updated() {
    setTimeout(function (){
      $(".select-contain-select").selectpicker('refresh');
    },100)
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  },
  beforeMount() {
    this.$store.commit("setSelectedPricingPeriodId", 0);
  }
}
</script>

<style scoped>

.price-input{
  padding: 5px!important;
  background-color: #f5f5ff!important;
  width: 65px;
}

</style>